export default __webpack_public_path__ + "static/media/bux_gig.eab572aa.svg";